import { FunctionComponent, ReactNode } from 'react'
import contextToiTeaser from '@contexts/toiTeaser'
import useNewstickerScribblePolling from '@hooks/useNewstickerScribblePolling'

const { TOITeaserNewstickerContext } = contextToiTeaser

interface TOITeaserNewstickerContextProviderProps {
  scribbleId?: string
  children?: ReactNode
}

const TOITeaserNewstickerContextProvider: FunctionComponent<
  TOITeaserNewstickerContextProviderProps
> = ({ scribbleId, children }) => {
  const { data: scribbleData } = useNewstickerScribblePolling({
    streamId: scribbleId,
  })

  return (
    <TOITeaserNewstickerContext.Provider
      value={{ posts: scribbleData?.posts ?? [] }}>
      {children}
    </TOITeaserNewstickerContext.Provider>
  )
}

export default TOITeaserNewstickerContextProvider
